module.exports = __webpack_public_path__ + "static/media/Y12.7cfc5c2f.mp3";